export default __webpack_public_path__ + "static/media/JULURI_HARSHINI.336f1c98.jpg";